import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../api';
import { setMessage } from '../../../redux/slice';

export const doGetCarriers = createAsyncThunk('carriers/doGetCarriers', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getCarriers(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateCarrier = createAsyncThunk('carriers/doCreateCarrier', async (params, thunkAPI) => {
  try {
    console.log({ params });
    const { response, error } = await api.doCreateCarrier(params);
    if (!error) thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateCarrier = createAsyncThunk('carriers/doUpdateCarrier', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateCarrier(params);
    if (!error) thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
